/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { PHDocumentController } from "document-model";
import { SubgraphModule } from "../module.js";
import type { SubgraphModuleAction, SubgraphModulePHState } from "./types.js";

export const SubgraphModuleController = PHDocumentController.forDocumentModel<
  SubgraphModulePHState,
  SubgraphModuleAction
>(SubgraphModule);
